<app-bina-catalog-item
  *ngFor="
    let favoriteHts of catalogList | async | paginate : { id: paginationListId, itemsPerPage: limit, currentPage: page, totalItems: total }
  "
  [favoriteHtsNumber]="favoriteHts"
  [type]="enumBinaCatalogItemType.UPDATED_AND_NOT_SUBJECT_TO_QUOTAS"
  (delete)="deleteItem.emit($event)"
  (openCalculator)="openCalculator.emit($event)"
  (reclassify)="reclassify.emit($event)"
  (history)="history.emit($event)"
></app-bina-catalog-item>
